import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, resolveDirective as _resolveDirective, withDirectives as _withDirectives, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "path-picker" }
const _hoisted_2 = { class: "selected-path" }
const _hoisted_3 = {
  key: 0,
  class: "icon"
}
const _hoisted_4 = {
  class: "dropdown-menu",
  id: "dropdown-menu",
  role: "menu"
}
const _hoisted_5 = { class: "dropdown-content" }
const _hoisted_6 = ["onClick"]
const _hoisted_7 = { class: "goto-button" }
const _hoisted_8 = ["disabled"]
const _hoisted_9 = { class: "icon" }

import { ref, computed, watch, onMounted, onBeforeUnmount } from 'vue';
import { useStore } from 'vuex';
import { nanoid } from 'nanoid';
import { dropDownHelper } from '@/shared/components/dropDownMenu/dropDownHelper';
import { PathViewModel } from '@/features/bots/models/designer';
import { ADD_PATH, SET_CURRENT_PATH } from '@/store/bot-designer/paths/mutationTypes';


export default /*@__PURE__*/_defineComponent({
  __name: 'PathPicker',
  props: {
    value: {},
    fixed: { type: Boolean }
  },
  emits: ['path-selected'],
  setup(__props: any, { emit: __emit }) {

const props = __props;
const emit = __emit;
const store = useStore();

const paths = computed<PathViewModel[]>(() => store.getters.paths);
const currentPathId = computed<string | undefined>(() => store.getters.currentPathId);
const selected = ref(props.value);
const isOpen = ref(false);
const isUp = ref(false);

watch(
  () => props.value,
  (newValue) => {
    selected.value = newValue;
  },
  { immediate: true },
);

const pathsToChooseFrom = computed(() => {
  return paths.value.filter((p) => p.id !== currentPathId.value);
});

const description = computed(() => {
  if (!selected.value) return 'Choose a path...';
  const selectedPath = paths.value.find((p) => p.id === selected.value);
  if (!selectedPath) {
    selected.value = '';
    emit('path-selected', selected.value);
    return 'Choose a path...';
  }
  return selectedPath.name;
});

const choosePath = (pathId: string) => {
  selected.value = pathId;
  emit('path-selected', selected.value);
};

const addNewPath = () => {
  const newPath: PathViewModel = {
    id: `path-${nanoid(7)}`,
    name: 'New Path',
    states: [],
  };
  store.commit(ADD_PATH, newPath);
  selected.value = newPath.id;
  emit('path-selected', selected.value);
};

const closePicker = () => {
  isOpen.value = false;
  isUp.value = false;
};

const togglePicker = () => {
  if (props.fixed) return;
  isOpen.value = !isOpen.value;
  if (isOpen.value) {
    setTimeout(() => {
      isUp.value = dropDownHelper.isDropDownUp();
    }, 0);
  }
};

const hasSelectedPath = (pathId: string) => {
  return pathId && pathId.length > 0;
};

const goToPath = (pathId: string) => {
  store.commit(SET_CURRENT_PATH, pathId);
};

const handleClickOutside = (event: Event) => {
  if (!event.target || !(event.target as HTMLElement).closest('.dropdown')) {
    closePicker();
  }
};

onMounted(() => {
  document.addEventListener('click', handleClickOutside);
});

onBeforeUnmount(() => {
  document.removeEventListener('click', handleClickOutside);
});

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!
  const _directive_click_away = _resolveDirective("click-away")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", {
      class: _normalizeClass(["dropdown", { 'is-active': isOpen.value, 'is-up': isUp.value }])
    }, [
      _withDirectives((_openBlock(), _createElementBlock("div", {
        class: "dropdown-trigger",
        onClick: togglePicker
      }, [
        _createElementVNode("button", {
          class: _normalizeClass(["button", { fixed: _ctx.fixed }])
        }, [
          _createElementVNode("span", _hoisted_2, _toDisplayString(description.value), 1),
          (!_ctx.fixed)
            ? (_openBlock(), _createElementBlock("span", _hoisted_3, [
                _createVNode(_component_font_awesome_icon, { icon: "angle-down" })
              ]))
            : _createCommentVNode("", true)
        ], 2)
      ])), [
        [_directive_click_away, closePicker]
      ]),
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(pathsToChooseFrom.value, (path) => {
            return (_openBlock(), _createElementBlock("a", {
              onClick: ($event: any) => (choosePath(path.id)),
              class: "dropdown-item",
              key: path.id
            }, _toDisplayString(path.name), 9, _hoisted_6))
          }), 128)),
          _cache[1] || (_cache[1] = _createElementVNode("hr", { class: "dropdown-divider" }, null, -1)),
          _createElementVNode("a", {
            onClick: addNewPath,
            class: "dropdown-item"
          }, " Add new path ")
        ])
      ])
    ], 2),
    _createElementVNode("div", _hoisted_7, [
      _createElementVNode("button", {
        class: "button",
        onClick: _cache[0] || (_cache[0] = ($event: any) => (goToPath(selected.value))),
        disabled: !hasSelectedPath(selected.value)
      }, [
        _createElementVNode("span", _hoisted_9, [
          _createVNode(_component_font_awesome_icon, { icon: "arrow-right" })
        ])
      ], 8, _hoisted_8)
    ])
  ]))
}
}

})